import React from 'react'
import spinnerImg from "../../assets/images/spinner.gif"

const SpinnerComponent = () => {
  return (
    <div>
        <img src={spinnerImg} alt="spinner" />
    </div>
  )
}

export default SpinnerComponent;